<router-outlet></router-outlet>
<ng-container *ngIf="activatedRoute.children.length === 0">
  <app-state [state]="state">
    <ng-container *ngIf="!state.loading && !state.error">
      <ng-container *ngIf="companyDirectories.length > 0; else templateNoDirectoriesExist;">
        <div class="card">
          <div class="content">
            <app-header [title]="'External directories'" [description]="'The external directories that your company is synchronised with can be found below.'"></app-header>

            <div class="row scroll-x">
              <table width="100%">
                <tr class="frankli-table frankli-table-small frankli-table-header noselect header-sticky">
                  <th>Name</th>
                  <th class="text-right" width="1em">Created On</th>
                  <th class="text-left" width="1em">Actions</th>
                </tr>
                <ng-container *ngFor="let companyDirectory of companyDirectories">
                  <tr class="frankli-table frankli-table-single-line">
                    <td>
                      <span>{{companyDirectory.name}}</span>
                    </td>
                    <td class="text-right">
                      <span>{{companyDirectory.created | amLocal | amDateFormat: 'yyyy-MM-DD'}}</span>
                    </td>
                    <td class="text-center">
                      <app-table-action-icon [hoverColor]="eIconHoverColor.RED" [icon]="'fa-times'" [tooltipText]="'Delete company directory'" (click)="deleteCompanyDirectory(companyDirectory)"></app-table-action-icon>
                    </td>
                  </tr>
                </ng-container>
              </table>
            </div>

            <div class="text-center p-top-15">
              <app-button [type]="eButtonType.GREEN_INVERTED" (onClick)="navigateToCreateDirectory()">Add a new directory</app-button>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="content">
            <app-header [title]="'Provisioned users'" [description]="'Any users who are provisioned from the above directories will be shown below. If there is an issue during the provisioning of any user, it will be visible below.'"></app-header>

            <ng-container *ngIf="scimUsers.master.length > 0; else templateNoProvisionedUsers;">
              <ng-container *ngFor="let scimUser of scimUsers.page">
                <div class="card">
                  <div class="content">
                    <div class="p-bottom-15">
                      <h5 class="standard-heading">
                        <span>{{scimUser.firstName}} {{scimUser.lastName}}</span>
                        <!-- <span class="m-right-5"></span>
                        <span>({{scimUser.username}})</span> -->
                        <span class="m-right-5"></span>
                        <ng-container *ngIf="scimUser.active; else templateStateInactive;">
                          <app-pill [minWidth]="0" [type]="ePillType.GREEN">Active</app-pill>
                        </ng-container>
                        <ng-template #templateStateInactive>
                          <app-pill [minWidth]="0" [type]="ePillType.YELLOW">Inactive</app-pill>
                        </ng-template>
                      </h5>
                      <div class="standard-description">{{scimUser.email}}</div>
                    </div>

                    <div>
                      <strong class="m-right-5">Position:</strong>
                      <span>{{scimUser.positionTitle ? scimUser.positionTitle : 'Role pending'}}</span>
                    </div>
                    <div>
                      <strong class="m-right-5">Department:</strong>
                      <span>{{scimUser.departmentName ? scimUser.departmentName : 'No department'}}</span>
                    </div>
                    <div>
                      <strong class="m-right-5">Office location:</strong>
                      <span>{{scimUser.officeLocationName ? scimUser.officeLocationName : 'No site'}}</span>
                    </div>
                    <div>
                      <strong class="m-right-5">Manager:</strong>
                      <span>{{scimUser.managerName}}</span>
                    </div>
                    <div>
                      <strong class="m-right-5">Start date:</strong>
                      <span>{{scimUser.startDate ? (scimUser.startDate | momentPipe: "Do MMM YYYY" ) :  'No start date'}}</span>
                    </div>

                    <ng-container *ngIf="scimUser.error">
                      <div class="card card-red m-top-15">
                        <div class="content">
                          <span class="fal fa-fw fa-exclamation-circle"></span>
                          <span class="m-right-15"></span>
                          <span class="d-inline-block v-align-middle">
                            <div>There was an error while provisioning this user:&nbsp;</div>
                            <div>{{scimUser.error}}</div>
                          </span>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <app-pagination-new-component [arrayData]="scimUsers.master" [arrayDisplay]="scimUsers.page" #pagination></app-pagination-new-component>
            </ng-container>
            <ng-template #templateNoProvisionedUsers>
              <app-empty-state [height]="'300px'" [message]="'No users have been added through the integration yet.'"></app-empty-state>
            </ng-template>
          </div>
        </div>
      </ng-container>

      <ng-template #templateNoDirectoriesExist>
        <div class="card">
          <div class="content">
            <app-header [title]="'Synchronise users from an external directory'" [description]="'You can automatically provision and de-provision users from your identity provider (such as Azure Active Directory). Once synchronised, all users in scope will be managed and kept up-to-date in Frankli by your identity provider.'" [helpLink]="'https://help.frankli.io/en/articles/5429197-how-do-i-set-up-user-provisioning-and-de-provisioning-with-azure-active-directory'"></app-header>

            <hr class="row">

            <div class="text-center">
              <app-button (onClick)="navigateToCreateDirectory()">Setup a Directory</app-button>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </app-state>
</ng-container>